import { useEffect, useState } from "react";

export const useLearningAuthentication = () => {
  const [isAuthend, setIsAuthend] = useState(false);

  const onReadAuth = () => {
    setIsAuthend(localStorage.getItem('learning_auth') === 'true');
  }

  const onVerifyAuth = (password: string) => {
    if(password === '1129') {
      localStorage.setItem('learning_auth', 'true');
      setIsAuthend(true);
    } else {
      localStorage.setItem('learning_auth', 'false');
      setIsAuthend(false);
    }
  }

  useEffect(() => {
    onReadAuth();
  }, []);

  return {
    isAuthend,
    onVerifyAuth,
  }
}